import { render, staticRenderFns } from "./PaymentMethodDetail.vue?vue&type=template&id=ddb4de46"
import script from "../../controllers/payment_method/payment-method-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment_method/payment-method-detail.js?vue&type=script&lang=js&external"
import style0 from "./PaymentMethodDetail.vue?vue&type=style&index=0&id=ddb4de46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports